import * as MuiSelect from '@mui/material/Select'
import React, { ForwardedRef } from 'react'

export type SelectProps<T = unknown> = MuiSelect.SelectProps<T>

export type SelectChangeEvent<T> = MuiSelect.SelectChangeEvent<T>

export const SelectMultiple = React.forwardRef(
  (
    { children, ...props }: SelectProps<unknown>,
    ref: ForwardedRef<HTMLSelectElement>,
  ) => (
    <MuiSelect.default ref={ref} {...props}>
      {children}
    </MuiSelect.default>
  ),
)
